import _ from 'underscore';
const alphanum = (incomingA, incomingB) => {
  let a = incomingA;
  let b = incomingB;
  a = a ? a.toLowerCase().replace(/ /g, '') : '';
  b = b ? b.toLowerCase().replace(/ /g, '') : '';
  const chunkify = t => {
    const tz = [];
    let x = 0;
    let y = -1;
    let n = 0;
    let i;
    let j;

    // Note (jrw): I tried to rewrite this with no lint exceptions, but it screws up the logic
    /* eslint-disable no-cond-assign, no-plusplus */
    while (i = (j = t.charAt(x++)).charCodeAt(0)) {
      /* eslint-enable no-cond-assign */
      const m = i === 46 || i >= 48 && i <= 57; // period or digit
      if (m !== n) {
        tz[++y] = '';
        /* eslint-enable no-plusplus */
        n = m;
      }
      tz[y] += j;
    }
    return tz;
  };
  const aa = chunkify(a);
  const bb = chunkify(b);
  for (let x = 0; aa[x] && bb[x]; x += 1) {
    if (aa[x] !== bb[x]) {
      const c = Number(aa[x]);
      const d = Number(bb[x]);
      /* eslint-disable eqeqeq */
      if (c == aa[x] && d == bb[x]) {
        /* eslint-enable eqeqeq */
        if (c !== 0 || d !== 0) {
          // special case handling of zeros
          return c - d;
        }
        return a > b ? 1 : -1;
      }
      return aa[x] > bb[x] ? 1 : -1;
    }
  }
  return aa.length - bb.length;
};
export const naturalSortBy = (obj, value, context) => {
  const iterator = _.isFunction(value) ? value : newObj => newObj[value];
  /* eslint-disable no-shadow */
  return _.pluck(_.map(obj, (value, index, list) => ({
    value,
    index,
    criteria: iterator.call(context, value, index, list)
  })).sort((left, right) => {
    const a = left.criteria;
    const b = right.criteria;
    return alphanum(a, b);
  }), 'value');
};
export const alhaNumSort = (a, b) => alphanum(a, b);